import { useConfiguration } from '../../../hooks/useConfiguration';
import useLanguage from '../../../hooks/useLanguage';
import user from '../../../helpers/user';
import { B2B_ACCOUNT_PAGE_LINKS, B2C_ACCOUNT_PAGE_LINKS } from '@intigral/constant';
import { getManageAddonsLink } from '../utils/addonsUtils';
import mixpanel from 'mixpanel-browser';
import { __ } from '../../../translations';

export const useAddonsRedirection = () => {
    const language = useLanguage();
    const { data: configuration } = useConfiguration();
    const { operator } = user.getUserInfo() || {};

    const redirectToAddonsPage = (item, carousel) => {
        const ctaName = item?.isStatic
            ? 'static banner'
            : item?.status === 'Subscribed'
            ? 'manage addon'
            : 'subscribe now';
        let carouselName = '';
        let offerName = '';

        const baseUrl = language === 'en' ? item?.url?.en : item?.url?.ar;
        let redirectUrl = '';
        if (item?.subscriptionGuid?.startsWith('NETFLIX')) {
            offerName = item?.isPickAndChoose ? 'Pick and Choose' : item?.isBundleAndSave ? 'Bundle & Save' : 'None';
            carouselName = item?.isPickAndChoose ? 'Pick and Choose' : 'Bundle & Save';
            let netflixRedirectUrl = '';
            if (item?.isBundleAndSave) {
                if (item?.status !== 'Subscribed') {
                    netflixRedirectUrl =
                        baseUrl +
                        `#${B2C_ACCOUNT_PAGE_LINKS.BUNDLE_SAVE_PURCHASE_ADDON}?subGuid=${item?.subscriptionGuid}`;
                } else {
                    netflixRedirectUrl = baseUrl + `#${B2C_ACCOUNT_PAGE_LINKS.MANAGE_ADDON}`;
                }
            } else {
                if (item?.status !== 'Subscribed') {
                    netflixRedirectUrl = baseUrl + `#${B2B_ACCOUNT_PAGE_LINKS.FREE_ADDON_LINK}`;
                } else {
                    netflixRedirectUrl = getManageAddonsLink(configuration, language, operator);
                }
            }
            mixpanel.track('Add-on carousel CTA clicked', {
                'Carousel Name': carouselName,
                'Add-on name': item?.subscriptionTitle ? item?.subscriptionTitle : 'None',
                'Offer name': offerName,
                'Screen name': 'Home',
                'CTA Name': ctaName,
            });
            window.location.href = netflixRedirectUrl;
            return;
        }
        // first determine that if operator is allowed for pick and choose
        if (configuration?.pickAndChoose?.allowedOperators?.includes(operator)) {
            // first check the title is static then redirect to free addons page
            if (item?.isStatic) {
                redirectUrl = baseUrl + `#${B2B_ACCOUNT_PAGE_LINKS.FREE_ADDON_LINK}&source=wcp`;
                offerName = 'Pick and Choose';
                carouselName = 'Pick and Choose';
            } else {
                offerName = item?.isPickAndChoose
                    ? 'Pick and Choose'
                    : item?.isBundleAndSave
                    ? 'Bundle & Save'
                    : 'None';
                carouselName = item?.isPickAndChoose ? 'Pick and Choose' : 'Bundle & Save';
                // check if the addons is already subscribed then redirect to manage addons page
                if (item?.status === 'Subscribed') {
                    redirectUrl = baseUrl + `#${B2B_ACCOUNT_PAGE_LINKS.MANAGE_ADDON_LINK}`;
                } else {
                    // check if addon is free then redirect to free addons page with selected sub subGuid else redirect to paid addons page
                    if (item?.serviceCollectionId) {
                        redirectUrl =
                            baseUrl +
                            `#${B2B_ACCOUNT_PAGE_LINKS.FREE_ADDON_LINK}&subGuid=${item?.subscriptionGuid}&source=wcp`;
                    } else {
                        redirectUrl =
                            baseUrl + `#${B2B_ACCOUNT_PAGE_LINKS.PAID_ADDON_LINK}?subGuid=${item?.subscriptionGuid}`;
                    }
                }
            }
        } else {
            if (item?.status === 'Subscribed') {
                redirectUrl = baseUrl + `#${B2C_ACCOUNT_PAGE_LINKS.MANAGE_ADDON}`;
            } else {
                if (item?.isBundleAndSave || item?.isStatic) {
                    offerName = 'Bundle & Save';
                    carouselName = 'Bundle & Save';
                    redirectUrl =
                        baseUrl +
                        `#${B2C_ACCOUNT_PAGE_LINKS.BUNDLE_SAVE_PURCHASE_ADDON}?subGuid=${item?.subscriptionGuid}`;
                } else {
                    offerName = item?.isPickAndChoose
                        ? 'Pick and Choose'
                        : item?.isBundleAndSave
                        ? 'Bundle & Save'
                        : 'None';
                    carouselName = item?.isPickAndChoose ? 'Pick and Choose' : 'Bundle & Save';
                    redirectUrl =
                        baseUrl + `#${B2C_ACCOUNT_PAGE_LINKS.PURCHASE_ADDON}?subGuid=${item?.subscriptionGuid}`;
                }
            }
        }
        mixpanel.track('Add-on carousel CTA clicked', {
            'Carousel Name': carouselName,
            'Add-on name': item?.subscriptionTitle ? item?.subscriptionTitle : 'None',
            'Offer name': offerName,
            'Screen name': 'Home',
            'CTA Name': ctaName,
        });
        window.location.href = redirectUrl;
    };

    const redirectToAddonsDetailsPage = (item, carousel) => {
        const ctaName = 'details';
        const offerName = item?.isPickAndChoose ? 'Pick and Choose' : item?.isBundleAndSave ? 'Bundle & Save' : 'None';
        const carouselName = item?.isPickAndChoose ? 'Pick and Choose' : 'Bundle & Save';
        mixpanel.track('Add-on carousel CTA clicked', {
            'Carousel Name': carouselName,
            'Add-on name': item?.subscriptionTitle,
            'Offer name': offerName,
            'Screen name': 'Home',
            'CTA Name': ctaName,
        });
        const baseUrl = language === 'en' ? item?.url?.en : item?.url?.ar;
        let redirectUrl = '';
        if (item?.subscriptionGuid?.startsWith('NETFLIX')) {
            let netflixRedirectUrl = '';
            if (item?.isBundleAndSave) {
                if (item?.status !== 'Subscribed') {
                    netflixRedirectUrl =
                        baseUrl +
                        `#${B2C_ACCOUNT_PAGE_LINKS.BUNDLE_SAVE_PURCHASE_ADDON}?subGuid=${item?.subscriptionGuid}&showDetails=true`;
                } else {
                    netflixRedirectUrl = baseUrl + `#${B2C_ACCOUNT_PAGE_LINKS.MANAGE_ADDON}`;
                }
            } else {
                if (item?.status !== 'Subscribed') {
                    netflixRedirectUrl = baseUrl + `#${B2B_ACCOUNT_PAGE_LINKS.FREE_ADDON_LINK}`;
                } else {
                    netflixRedirectUrl = getManageAddonsLink(configuration, language, operator);
                }
            }
            window.location.href = netflixRedirectUrl;
            return;
        }
        // first determine that if operator is allowed for pick and choose
        if (configuration?.pickAndChoose?.allowedOperators?.includes(operator)) {
            // check if addon is free then redirect to free addons page with selected sub subGuid else redirect to paid addons page
            if (item?.status === 'Subscribed') {
                redirectUrl =
                    baseUrl +
                    `#${B2B_ACCOUNT_PAGE_LINKS.MANAGE_ADDON_LINK}?subGuid=${item?.subscriptionGuid}&showDetails=true`;
            } else {
                if (item?.serviceCollectionId) {
                    redirectUrl =
                        baseUrl +
                        `#${B2B_ACCOUNT_PAGE_LINKS.FREE_ADDON_LINK}&subGuid=${item?.subscriptionGuid}&showDetails=true&source=wcp`;
                } else {
                    redirectUrl =
                        baseUrl +
                        `#${B2B_ACCOUNT_PAGE_LINKS.PAID_ADDON_LINK}?subGuid=${item?.subscriptionGuid}&showDetails=true`;
                }
            }
        } else {
            if (item?.status === 'Subscribed') {
                redirectUrl =
                    baseUrl +
                    `#${B2C_ACCOUNT_PAGE_LINKS.MANAGE_ADDON}?subGuid=${item?.subscriptionGuid}&showDetails=true`;
            } else {
                if (item?.isBundleAndSave || item?.isStatic) {
                    redirectUrl =
                        baseUrl +
                        `#${B2C_ACCOUNT_PAGE_LINKS.BUNDLE_SAVE_PURCHASE_ADDON}?subGuid=${item?.subscriptionGuid}&showDetails=true`;
                } else {
                    redirectUrl =
                        baseUrl +
                        `#${B2C_ACCOUNT_PAGE_LINKS.PURCHASE_ADDON}?subGuid=${item?.subscriptionGuid}&showDetails=true`;
                }
            }
        }
        window.location.href = redirectUrl;
    };

    return {
        redirectToAddonsPage,
        redirectToAddonsDetailsPage,
    };
};
